import { render, staticRenderFns } from "./ItemEmpleadoBaja.vue?vue&type=template&id=0bc7c764&"
import script from "./ItemEmpleadoBaja.vue?vue&type=script&lang=js&"
export * from "./ItemEmpleadoBaja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports